export class Configurations {
  id: string;
  data: any[];
}



// WEBPACK FOOTER //
// /ng-app/src/app/configurations/shared/configurations.model.ts